import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SuperAdminBatchDetailsResponse } from '@edtech-ui/core/models/admin-panel/batch-management/batch-detail-page';
import { SuperAdminBatchDataResponse, SuperAdminCreateBatchPayload } from '@edtech-ui/core/models/admin-panel/batch-management/create-batch';
import { DeleteBatchesResponse } from '@edtech-ui/core/models/admin-panel/batch-management/delete-batches';
import { SuperAdminEditBatchPayload, SuperAdminEditBatchResponse } from '@edtech-ui/core/models/admin-panel/batch-management/edit-batches';
import { GetAllTenantsBatchesResponse } from '@edtech-ui/core/models/admin-panel/batch-management/get-all-tenants-batches';
import { environment } from 'environments/environment';
import { Observable, Subject, tap } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class BatchManagementService {

	apiUrl = environment.batchApiUrl;
	reload$ = new Subject<void>;

	constructor(private http: HttpClient) { }


	postBatch(payload: SuperAdminCreateBatchPayload): Observable<SuperAdminBatchDataResponse> {
		return this.http.post<SuperAdminBatchDataResponse>(`${this.apiUrl}/createBatch`, payload);
	}

	getAllTenantsBatches(): Observable<GetAllTenantsBatchesResponse> {
		return this.http.get<GetAllTenantsBatchesResponse>(`${this.apiUrl}/getBatchesByTenant`);
	}

	deleteAllBatches(batchId: number): Observable<DeleteBatchesResponse> {
		return this.http.delete<DeleteBatchesResponse>(`${this.apiUrl}/deleteBatch/${batchId}`).pipe(
			tap(()=> this.reload$.next()));
	}

	putUpdateBatch(batchId:number,payload:SuperAdminEditBatchPayload):Observable<SuperAdminEditBatchResponse>{
		return this.http.put<SuperAdminEditBatchResponse>(`${this.apiUrl}/updateBatch/${batchId}`,payload).pipe(
			tap(()=> this.reload$.next()));
	}

	getBatchDetailsById(batchId:number):Observable<SuperAdminBatchDetailsResponse>{
		return this.http.get<SuperAdminBatchDetailsResponse>(`${this.apiUrl}/batches/${batchId}/details`)
	}

}